import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-validations',
  templateUrl: './setting-validations.component.html',
  styleUrls: ['./setting-validations.component.scss']
})
export class SettingValidationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
